import styled from "styled-components";

export const ProcessorModalStyle = styled.div`
    .ant-checkbox-group, .ant-radio-group {
        display: flex;
        flex-direction: column;
    }
`;
